export default "__VITE_ASSET__vJKwAjMr__"